export enum PaymentTerms {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  BI_MONTHLY = 'bi_monthly',
  NET0 = 'net0',
  NET15 = 'net15',
  NET20 = 'net20',
  NET30 = 'net30',
  NET60 = 'net60',
  NET90 = 'net90',
}
